import { render, staticRenderFns } from "./Datapoint.vue?vue&type=template&id=4b1969ca&scoped=true"
import script from "./Datapoint.vue?vue&type=script&lang=ts"
export * from "./Datapoint.vue?vue&type=script&lang=ts"
import style0 from "./Datapoint.vue?vue&type=style&index=0&id=4b1969ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1969ca",
  null
  
)

export default component.exports